/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedRedemptionsResponse } from '../../models/paged-redemptions-response';

export interface GetRedemptions$Params {
  'Active-Tenant-Identifier': string;
  page?: number;
  size?: number;
  sortField?: Array<string>;
  sortDirection?: Array<string>;
  filter?: Array<string>;
}

export function getRedemptions(http: HttpClient, rootUrl: string, params: GetRedemptions$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedRedemptionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getRedemptions.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sortField', params.sortField, {"style":"form","explode":true});
    rb.query('sortDirection', params.sortDirection, {"style":"form","explode":true});
    rb.query('filter', params.filter, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedRedemptionsResponse>;
    })
  );
}

getRedemptions.PATH = '/redemptions';
